document.querySelectorAll('[data-cj-product]').forEach((section) => {
  const variants = JSON.parse(section.querySelector('[data-cj-variants]').textContent);
  const moneyFormat = JSON.parse(section.querySelector('[data-cj-money-format]').textContent);
  const idInput = section.querySelector('[data-cj-variant-id]');
  const price = section.querySelector('[data-cj-price]');
  const compare = section.querySelector('[data-cj-compare]');
  const submit = section.querySelector('[data-cj-submit]');
  const optionInputs = [...section.querySelectorAll('[data-cj-option]')];
  const demoSwatches = [...section.querySelectorAll('[data-cj-demo-swatch]')];
  const demoColor = section.querySelector('[data-cj-demo-color]');
  const galleryTiles = [...section.querySelectorAll('[data-media-id]')];
  const addLabel = section.dataset.cjAddLabel || submit.textContent.trim();
  const soldLabel = section.dataset.cjSoldOutLabel || 'Sold out';

  const money = (cents) => {
    const value = Number(cents || 0) / 100;
    const formatted = moneyFormat
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(value).toString())
      .replace(/\{\{\s*amount\s*\}\}/g, value.toFixed(2));
    const clean = document.createElement('span');
    clean.innerHTML = formatted;
    return clean.textContent || formatted;
  };

  const selected = () => {
    const options = [];
    optionInputs.forEach((input) => {
      if (input.checked) options[Number(input.dataset.cjOptionPosition) - 1] = input.value;
    });
    return options;
  };

  const updateLabels = () => {
    optionInputs.forEach((input) => {
      if (!input.checked) return;
      const label = section.querySelector(`[data-cj-option-label="${input.dataset.cjOptionPosition}"]`);
      if (label) label.textContent = ` ${input.value}`;
    });
  };

  const updateGallery = (variant) => {
    if (!galleryTiles.length) return;

    const variantId = variant ? String(variant.id) : '';
    let visibleCount = 0;

    galleryTiles.forEach((tile) => {
      const variantIds = (tile.dataset.cjVariantIds || '').split(',').filter(Boolean);
      const hide = tile.hasAttribute('data-cj-variant-media') && !variantIds.includes(variantId);

      tile.hidden = hide;
      tile.classList.toggle('is-hidden', hide);
      if (!hide) visibleCount += 1;
    });

    if (visibleCount === 0) {
      galleryTiles[0].hidden = false;
      galleryTiles[0].classList.remove('is-hidden');
    }
  };

  const update = () => {
    updateLabels();
    const opts = selected();
    const variant = variants.find((item) => item.options.every((value, index) => value === opts[index]));
    if (!variant) {
      updateGallery(null);
      return;
    }

    idInput.value = variant.id;
    price.textContent = money(variant.price);

    if (compare) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compare.textContent = money(variant.compare_at_price);
        compare.hidden = false;
      } else {
        compare.hidden = true;
      }
    }

    submit.disabled = !variant.available;
    submit.textContent = variant.available ? addLabel : soldLabel;
    updateGallery(variant);

    if (variant.featured_media && variant.featured_media.id) {
      const tile = section.querySelector(`[data-media-id="${variant.featured_media.id}"]`);
      if (tile && window.matchMedia('(max-width: 749px)').matches) {
        tile.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      }
    }
  };

  optionInputs.forEach((input) => input.addEventListener('change', update));
  demoSwatches.forEach((button) => {
    button.addEventListener('click', () => {
      demoSwatches.forEach((item) => item.classList.remove('is-active'));
      button.classList.add('is-active');
      if (demoColor) demoColor.textContent = ` ${button.dataset.color || ''}`;
    });
  });

  update();
});
